import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import theme from "@/store/theme"; // Importa theme ALL'INIZIO
import UsersLogin from "../views/UsersLogin.vue";
import HomePage from "../views/HomePage.vue";
import ConvProspettiPaghe from "../views/ConvProspettiPaghe.vue";
import ConvModelliF24 from "../views/ConvModelliF24.vue";
import ConvBilancioAnalitico from "../views/ConvBilancioAnalitico.vue";
import HelpMyStudio from "../views/InfoMyStudio.vue";
import LibreriaCodiciConto from "../views/LibreriaCodiciConto.vue";
import LibreriaBilanciAnalitici from "../views/LibreriaBilanciAnalitici.vue";
import MyStore from "../views/MyStore.vue";
import RewardShop from "../views/RewardShop.vue";
import AreaPersonale from "../views/AreaPersonaleDashboard.vue";
import AreaGestionale from "../views/AreaGestionale.vue";
import AreaAmministratore from "../views/AreaAmministratore.vue";
import LibreriaCodiciTributo from "@/views/LibreriaCodiciTributo.vue";
import ImpostazioniApp from "@/views/ImpostazioniApp.vue";
import MyPage from "@/MyGame/MyPage.vue";
import WelcomePage from "@/views/WelcomePage.vue";
import FileSystem from "@/views/FileSystem.vue";
import DiagnosticaConversioni from "@/views/DiagnosticaConversioni.vue";
import { API_BASE_URL } from "@/config";
import { isGuestMode } from "@/utils/guestMode";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  return originalPush.call(this, location).catch((error) => {
    if (
      error &&
      (error.name === "NavigationDuplicated" ||
        error.name === "NavigationAborted" ||
        error.name === "NavigationCancelled")
    ) {
      return error;
    }

    throw error;
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }

  return originalReplace.call(this, location).catch((error) => {
    if (
      error &&
      (error.name === "NavigationDuplicated" ||
        error.name === "NavigationAborted" ||
        error.name === "NavigationCancelled")
    ) {
      return error;
    }

    throw error;
  });
};

const routes = [
  {
    path: "/",
    name: "WelcomePage",
    component: WelcomePage,
    meta: { noDarkMode: true }, // Flag per disabilitare dark mode
  },
  {
    path: "/welcome",
    redirect: "/",
  },
  {
    path: "/users-login",
    name: "UsersLogin",
    component: UsersLogin,
    meta: { noDarkMode: true },
  },
  {
    path: "/home",
    name: "HomePage",
    component: HomePage,
    meta: { requiresAuth: true, breadcrumb: "Home" },
    children: [
      {
        path: "prospetti-paghe",
        name: "ConvProspettiPaghe",
        component: ConvProspettiPaghe,
        meta: { breadcrumb: "Prospetti Paghe" },
      },
      {
        path: "modelli-f24",
        name: "ConvModelliF24",
        component: ConvModelliF24,
        meta: { breadcrumb: "Modelli F24" },
      },
      {
        path: "bilancio-analitico",
        name: "ConvBilancioAnalitico",
        component: ConvBilancioAnalitico,
        meta: { breadcrumb: "Bilancio Analitico" },
      },
      {
        path: "help",
        name: "HelpMyStudio",
        component: HelpMyStudio,
        meta: { breadcrumb: "Help MyStudio" },
      },
      {
        path: "libreria-codici-conto",
        name: "LibreriaCodiciConto",
        component: LibreriaCodiciConto,
        meta: { breadcrumb: "Libreria Codici Conto" },
      },
      {
        path: "libreria-codici-tributo",
        name: "LibreriaCodiciTributo",
        component: LibreriaCodiciTributo,
        meta: { breadcrumb: "Libreria Codici Tributo" },
      },
      {
        path: "libreria-bilanci-analitici",
        name: "LibreriaBilanciAnalitici",
        component: LibreriaBilanciAnalitici,
        meta: { breadcrumb: "Libreria Bilanci Analitici" },
      },
      {
        path: "store",
        name: "MyStore",
        component: MyStore,
        meta: { breadcrumb: "Store" },
      },
      {
        path: "premi",
        name: "RewardShop",
        component: RewardShop,
        meta: { breadcrumb: "Premi" },
      },
      {
        path: "impostazioni",
        name: "ImpostazioniApp",
        component: ImpostazioniApp,
        meta: { breadcrumb: "Impostazioni" },
      },
      {
        path: "area-personale",
        name: "AreaPersonale",
        component: AreaPersonale,
        meta: { breadcrumb: "Area Personale" },
      },
      {
        path: "area-gestionale",
        name: "AreaGestionale",
        component: AreaGestionale,
        meta: { breadcrumb: "Il Mio Studio" },
      },
      {
        path: "anagrafica-clienti",
        name: "AnagraficaClienti",
        redirect: { name: "AreaGestionale", query: { tab: "clienti" } },
      },
      {
        path: "area-amministratore",
        name: "AreaAmministratore",
        component: AreaAmministratore,
        meta: {
          requiresAdminMyStudio: true,
          breadcrumb: "Area Amministratore",
        },
      },
      {
        path: "archivio-file-convertiti",
        name: "ArchivioFileConvertiti",
        redirect: { name: "AreaGestionale", query: { tab: "archivio" } },
      },
      {
        path: "file-system",
        name: "FileSystem",
        component: FileSystem,
        meta: { requiresAdminMyStudio: true, breadcrumb: "File System" },
      },
      {
        path: "diagnostica-conversioni",
        name: "DiagnosticaConversioni",
        component: DiagnosticaConversioni,
        meta: {
          requiresAdminMyStudio: true,
          breadcrumb: "Diagnostica Conversioni",
        },
      },
      {
        path: "adalberto",
        name: "MyPage",
        component: MyPage,
        meta: { breadcrumb: "Adalberto" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const guestBlockedRouteNames = new Set([
  "MyStore",
  "AreaGestionale",
  "AnagraficaClienti",
  "ArchivioFileConvertiti",
]);
const adminStudioTabs = new Set(["utenti", "files"]);

// AFTER EACH - Gestisce il tema dopo ogni navigazione
router.afterEach((to) => {
  theme.updateAfterNavigation(to);
  console.log("Theme updated for route:", to.path);
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isGuestMode()) {
      to.meta.studioAdmin = false;
      if (guestBlockedRouteNames.has(to.name)) {
        next({ name: "HomePage" });
        return;
      }
      next();
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/check_auth`);
      console.log("CHECK AUTH:", response.data);
      const isAdmin = response.data.is_admin || false;
      const isAdminMyStudio = response.data.is_admin_MyStudio || false;
      to.meta.studioAdmin = isAdmin || isAdminMyStudio;

      const cachedUser = JSON.parse(localStorage.getItem("user") || "{}");
      localStorage.setItem(
        "user",
        JSON.stringify({
          ...cachedUser,
          email: response.data.user_email || cachedUser.email || "",
          first_name: response.data.first_name || cachedUser.first_name || "",
          last_name: response.data.last_name || cachedUser.last_name || "",
          is_admin: isAdmin,
          is_admin_MyStudio: isAdminMyStudio,
          studio: {
            ...(cachedUser.studio || {}),
            nome:
              response.data.studio_nome || cachedUser.studio?.nome || "Studio",
            piano: response.data.piano || cachedUser.studio?.piano || "base",
          },
        })
      );

      if (
        to.matched.some((record) => record.meta.requiresAdmin) &&
        !(isAdmin || isAdminMyStudio)
      ) {
        next({ name: "HomePage" });
        return;
      }
      if (
        to.name === "AreaGestionale" &&
        adminStudioTabs.has(to.query.tab) &&
        !(isAdmin || isAdminMyStudio)
      ) {
        next({ name: "AreaGestionale", query: { tab: "studio" } });
        return;
      }
      if (
        to.matched.some((record) => record.meta.requiresAdminMyStudio) &&
        !isAdminMyStudio
      ) {
        next({ name: "HomePage" });
        return;
      }
      next();
    } catch (error) {
      console.log("ERRORE AUTH:", error);

      if (to.name !== "UsersLogin") {
        next({ name: "UsersLogin" });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
